import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import OtherService from '../services/Other'
import { Col, Container, Row } from 'react-bootstrap'
import Loader from '../component/Loader'
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const About = () => {
    const[isAboutData,setIsAboutData]=useState([]);
    const [loading, setLoading] = useState(true);
    const[isNoData,setIsNoData]=useState(false)
    useEffect(()=>{
        const userGuideDataFetch = async ()=>{
          try{
            const token = localStorage.getItem('access_token') 
            const responseUserGuide = await OtherService.aboutWeb(token)
           
            if(responseUserGuide.error == false && responseUserGuide.data.content_banner_details_contact.content_spot_contents.length > 0 )
            {
             
             setIsAboutData(responseUserGuide.data.content_banner_details_contact.content_spot_contents)
             setLoading(false)
             setIsNoData(false);
            }
            else{
              setLoading(false);
              setIsNoData(true);
            }
          }
          catch(e){
            console.error("Data fetch error");
          }
            
            }
        userGuideDataFetch()
    },[])
  return (
    <>
        {loading && <Loader/> }
        
        <BreadCrumbSecttion
         pageTitle="About"
         currentPageName="About"/>
        <section className='padTop50'>
        {isNoData &&  <div className='noDataMsg'>No data found!</div>}
        
        {!isNoData && 
           <div className="dashboard-details">
            <Container>
              <Row>
                    <Col xs={12}>
                        <section className='padTop50'>
                            <div className="userInfoBox">
                              {isAboutData?.map((item,index)=>{
                                const{content_map_id,article_detail,article_text}=item
                                return(
                                  <div key={content_map_id}>
                                        <h2 className='articleTitle'>{article_text}</h2>
                                       {/* <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(article_detail)}} className='mb-4'> */}
                                        <div>
                                          {parseSafeHtml(article_detail)}
                                        </div>
                                       {/* </div> */}
                                  </div>
                                )
                              })}
                            </div>
                        </section>
                    </Col>
                </Row>
                </Container>
           </div>
}
        </section>
       
    </>
  )
}

export default About